import {
  stepOtherExpenseLookup,
  stepTripCancellationAndTripInterruptionExpenseLookup,
  stepMedicalAndEvacuationLookup,
  stepBaggageAndPersonalItemsSCTILookup,
  stepChangesToYourJourneyLookup,
  stepCashBankCardsTravelDocumentsAndPassportsLookup,
  stepMedicalExpensesTugoLookup,
  stepRentalCarProtectionTravellerTugoLookup,
} from './claimCodeMapper';
import stepChangesToYourJourneyDataMapper from './stepChangesToYourJourneyDataMapper';
import stepMedicalExpenseCFDataMapper from './stepMedicalExpenseCFDataMapper';
import stepBaggageAndPersonalItemsStarrDataMapper from './stepBaggageAndPersonalItemsStarrDataMapper';
import stepBaggageAndPersonalItemsDataMapper from './stepBaggageAndPersonalItemsDataMapper';
import stepCollisionDamageDataMapper from './stepCollisionDamageDataMapper';
import stepCollisionDamageStarrDataMapper from './stepCollisionDamageStarrDataMapper';
import stepMedicalExpensesDataMapper from './stepMedicalExpensesDataMapper';
import stepOtherDataStarrMapper from './stepOtherDataStarrMapper';
import stepBaseVictorsMedicalTugoDataMapper from './stepBaseVictorsMedicalTugoDataMapper';
import stepStudentMedicalBenefitsTugoDataMapper from './stepStudentMedicalBenefitsTugoDataMapper';
import stepTripInterruptionTugoDataMapper from './stepTripInterruptionTugoDataMapper';
import stepTripInterruptionTravellerTugoDataMapper from './stepTripInterruptionTravellerTugoDataMapper';
import stepStandardVTCMedicalBenefitsTugoDataMapper from './stepStandardVTCMedicalBenefitsTugoDataMapper';
import stepTravellerMedicalBenefitsTugoDataMapper from './stepTravellerMedicalBenefitsTugoDataMapper';
import stepOptimumMedicalBenefitsTugoDataMapper from './stepOptimumMedicalBenefitsTugoDataMapper';
import stepOtherTugoDataMapper from './stepOtherDataTugoMapper';
import stepTripCancellationTugoDataMapper from './stepTripCancellationTugoDataMapper';
import stepTripCancellationTravellerTugoDataMapper from './stepTripCancellationTravellerTugoDataMapper';
import stepADAndDTugoDataMapper from './stepADAndDTugoDataMapper';
import stepADAndDTravellerTugoDataMapper from './stepADAndDTravellerTugoDataMapper';
import stepBaggageAndPersonalItemsTravellerTugoDataMapper from './stepBaggageAndPersonalItemsTravellerTugoDataMapper';
import stepRentalCarProtectionTravellerTugoDataMapper from './stepRentalCarProtectionTravellerTugoDataMapper';
import { LIST_POLICY_TYPE_CODE } from '../../App/constants';

function mapToParentSection(data) {
  return {
    signature: data.signature,
    date: data.date,
  };
}

function mapToQuestionnaire() {
  return [];
}

function mapToExpenses() {
  return [];
}

function mapQuestionItem(claimType, description) {
  return {
    claimCode: claimType.claimCode,
    description,
    claimTypeId: claimType.claimTypeId,
    requiredDocuments: claimType.requiredDocuments,
    parentBenefitCode: claimType.parentBenefitCode,
  };
}

function mapDocumentItems({
  claimTypesInit,
  policyTypeCode,
  policyPlanIds,
  selectedBenefits,
  stepTripCancellationAndTripInterruptionData,
  stepOtherData,
  stepMedicalAndEvacuationSCTIData,
  stepBaggageAndPersonalItemsSCTIData,
  stepCashBankCardsTravelDocumentsAndPassportsData,
  stepChangesToYourJourneySCTIData,
  stepChangesToYourJourneyData,
  stepBaggageAndPersonalItemsData,
  stepBaggageAndPersonalItemsStarrData,
  stepMedicalExpenseCFData,
  stepOtherStarrData,
  stepCollisionDamageData,
  stepCollisionDamageStarrData,
  stepMedicalExpensesData,
  stepMedicalExpensesTugoData,
  stepOtherTugoData,
  stepBaseVictorsMedicalTugoData,
  stepStudentMedicalBenefitsTugoData,
  stepTripCancellationTugoData,
  stepTripCancellationTravellerTugoData,
  stepTripInterruptionTugoData,
  stepStandardVTCMedicalBenefitsTugoData,
  stepTravellerMedicalBenefitsTugoData,
  stepOptimumMedicalBenefitsTugoData,
  stepADAndDBenefitsTugoData,
  stepBaggageAndPersonalItemsTravellerTugoData,
  stepRentalCarProtectionTravellerTugoData,
}) {
  // Trawick Benefits
  const isInternationalStudent = policyTypeCode === 'INT-ST-NZ';
  const policyTypeVisitingNZ = ['VISIT-NZ', 'VISIT-NZ-PI'];
  const isVisitingNewZealand = policyTypeVisitingNZ.includes(policyTypeCode);
  const policyTypeWorkingOverseas = ['WORK-AU', 'WORK-NZ'];
  const isWorkingOverseas = policyTypeWorkingOverseas.includes(policyTypeCode);
  const isShowSubBenefits = isInternationalStudent || isVisitingNewZealand || isWorkingOverseas;
  const { travelInterruption, tripCancellation, tripCancellationForAnyReason } = stepTripCancellationAndTripInterruptionData || {};
  const { areYouClaimingForAccidentalDeathAndDismemberment, areYouClaimingForRepatriationExpenses, areYouClaimingForBurialExpenses, whatExpensesAreYouClaimingFor, whatAreYourExpensesRelatedTo } = stepOtherData || {};
  const { didAnAccompanyingPersonTravelFromYourHomeCountryWhilstYouWereHospitalised, wasTheDeathCausedByAnInjury, whatExpensesAreYouClaimingFor: whatExpensesAreYouClaimingForMedicalAndEvacuationSCTI, whatAreYourExpensesRelatedTo: MAEWhatAreYourExpensesRelatedTo } = stepMedicalAndEvacuationSCTIData || {};
  const { whatHappenedToYourBaggageAndPersonalItems, whatItemsAreYouClaimingFor } = stepBaggageAndPersonalItemsSCTIData || {};
  const { whatItemsAreYouClaimingFor: passportItemsClaiming } = stepCashBankCardsTravelDocumentsAndPassportsData || {};
  const { haveYouCanceledOrChangedYourJourneyBeforeLeaving, haveYouChangedYourJourneyAfterLeaving, wasTheUnexpectedEventRelatedToTheRelevantPersonsExistingHealthCondition,
    wereYouChargedACancellationFeeByTheTravelAgent, wereYouDelayedWhileTravelingToASpecialEvent, wereYouDelayedWhileTravelingToASpecialEventAL,
    didYouAlsoIncurTheseCostsAsAResultOfYourTravelDisruption, wasTheUnexpectedEventRelatedToTheRelevantPersonsExistingHealthConditionAL } = stepChangesToYourJourneySCTIData || {};

  // Trawick UI
  const selectedBenefitsChangesToYourJourney = stepChangesToYourJourneyDataMapper.mapToClaimExpensesLevel(stepChangesToYourJourneyData, claimTypesInit, selectedBenefits);
  const selectedBenefitsMedicalExpense = stepMedicalExpenseCFDataMapper.mapToClaimExpensesLevel(stepMedicalExpenseCFData, claimTypesInit, selectedBenefits);
  const selectedBenefitsBaggageAndPersonalItems = stepBaggageAndPersonalItemsDataMapper.mapToClaimExpensesLevel(stepBaggageAndPersonalItemsData, claimTypesInit, selectedBenefits);
  const selectedBenefitsBaggageAndPersonalItemsStarr = stepBaggageAndPersonalItemsStarrDataMapper.mapToClaimExpensesLevel(stepBaggageAndPersonalItemsStarrData, claimTypesInit, selectedBenefits);
  const selectedBenefitsOtherStarr = stepOtherDataStarrMapper.mapToClaimExpensesLevel(stepOtherStarrData, claimTypesInit, selectedBenefits);
  const selectedBenefitsCollisionDamage = stepCollisionDamageDataMapper.mapToClaimExpensesLevel(stepCollisionDamageData, claimTypesInit, selectedBenefits);
  const selectedBenefitsCollisionDamageStarr = stepCollisionDamageStarrDataMapper.mapToClaimExpensesLevel(stepCollisionDamageStarrData, claimTypesInit, selectedBenefits);
  const selectedBenefitsMedicalExpenses = stepMedicalExpensesDataMapper.mapToClaimExpensesLevel(stepMedicalExpensesData, claimTypesInit, selectedBenefits);

  const expensesPersonalLiabilitySelected = !!whatExpensesAreYouClaimingFor && typeof whatExpensesAreYouClaimingFor.toJS === 'function'
    ? whatExpensesAreYouClaimingFor.toJS()
    : whatExpensesAreYouClaimingFor || [];
  const whatAreYourExpensesRelatedToSelected = !!whatAreYourExpensesRelatedTo && typeof whatAreYourExpensesRelatedTo.toJS === 'function'
    ? whatAreYourExpensesRelatedTo.toJS()
    : whatAreYourExpensesRelatedTo || [];
  const isPersonalLiabilitySelected = expensesPersonalLiabilitySelected.includes('Personal Liability');
  const isPersonalAccidentSelected = expensesPersonalLiabilitySelected.includes('Personal Accident');
  const isLossOfIncomeCodeSelected = whatAreYourExpensesRelatedToSelected.includes('Loss of Income');
  const isTotalPermanentDisablementCodeSelected = whatAreYourExpensesRelatedToSelected.includes('Total permanent disablement');
  const isLossOfLifeCodeSelected = whatAreYourExpensesRelatedToSelected.includes('Loss of Life');
  const list = [...(!!selectedBenefits && typeof selectedBenefits.toJS === 'function') ? selectedBenefits.toJS() : (selectedBenefits || [])]
    .filter((x) => x.description !== 'Other'
      && x.description !== 'Trip Cancellation & Trip Interruption'
      && x.description !== 'Medical and evacuation'
      && x.description !== 'Baggage and personal items'
      && x.description !== 'Changes to your journey'
      && x.description !== 'Medical Expenses'
      && x.description !== 'Cash, bank cards, travel documents and passports'
      && x.description !== 'Collision Damage'
      && x.description !== 'Medical Expenses - Visitors to Canada'
      && x.description !== 'Student Medical Benefits'
      && x.description !== 'Medical Expense'
      && x.description !== 'Trip Cancellation'
      && x.description !== 'Trip Interruption'
      && x.description !== 'Medical Benefits'
      && x.description !== 'AD&D'
      && !(stepRentalCarProtectionTravellerTugoLookup && stepRentalCarProtectionTravellerTugoLookup.claimCodeList && stepRentalCarProtectionTravellerTugoLookup.claimCodeList.includes(x.claimCode)));
  // Collision Damage
  if (selectedBenefitsCollisionDamage.length > 0) {
    list.push(...selectedBenefitsCollisionDamage);
  }

  // Collision Damage Starr
  if (selectedBenefitsCollisionDamageStarr.length > 0) {
    list.push(...selectedBenefitsCollisionDamageStarr);
  }

  // Medical Expenses
  if (selectedBenefitsMedicalExpenses.length > 0) {
    list.push(...selectedBenefitsMedicalExpenses);
  }

  // Baggage and personal items Trawick
  if (selectedBenefitsBaggageAndPersonalItems.length > 0) {
    list.push(...selectedBenefitsBaggageAndPersonalItems);
  }

  // Other Documents
  if ((areYouClaimingForRepatriationExpenses === 'true' || areYouClaimingForAccidentalDeathAndDismemberment === 'true' || areYouClaimingForBurialExpenses === 'true'
    || isPersonalLiabilitySelected || isPersonalAccidentSelected || isLossOfIncomeCodeSelected || isLossOfLifeCodeSelected || isTotalPermanentDisablementCodeSelected) && claimTypesInit !== undefined) {
    const code1 = stepOtherExpenseLookup.areYouClaimingForRepatriationExpenses.claimCode;
    const code2 = stepOtherExpenseLookup.areYouClaimingForAccidentalDeathAndDismemberment.claimCode;
    const code3 = stepOtherExpenseLookup.areYouClaimingForBurialExpenses.claimCode;
    const code4 = stepOtherExpenseLookup.personalLiability.claimCode;
    const code5 = stepOtherExpenseLookup.personalAccident.claimCode;
    const lossOfIncomeCode = stepOtherExpenseLookup.lossOfIncome.claimCode;
    const lossOfLifeCode = stepOtherExpenseLookup.lossOfLife.claimCode;
    const totalPermanentDisablementCode = stepOtherExpenseLookup.totalPermanentDisablement.claimCode;
    claimTypesInit.forEach(
      (item) => {
        if ((item.claimCode === code1 || item.parentBenefitCode === code1) && areYouClaimingForRepatriationExpenses === 'true') {
          const benefit = mapQuestionItem(item, 'Repatriation Expenses');
          if (!!benefit) {
            list.push(benefit);
          }
        }
        if ((item.claimCode === code2 || item.parentBenefitCode === code2) && areYouClaimingForAccidentalDeathAndDismemberment === 'true') {
          const benefit = mapQuestionItem(item, 'Accidental Death & Dismemberment');
          if (!!benefit) {
            list.push(benefit);
          }
        }
        if ((item.claimCode === code3 || item.parentBenefitCode === code3) && areYouClaimingForBurialExpenses === 'true') {
          const benefit = mapQuestionItem(item, 'Burial Expenses');
          if (!!benefit) {
            list.push(benefit);
          }
        }
        if ((item.claimCode === code4 || item.parentBenefitCode === code4) && isPersonalLiabilitySelected) {
          const benefit = mapQuestionItem(item, 'Personal Liability');
          if (!!benefit) {
            list.push(benefit);
          }
        }
        if ((item.claimCode === code5 || item.parentBenefitCode === code5) && isPersonalAccidentSelected) {
          const benefit = mapQuestionItem(item, 'Personal Accident');
          if (!!benefit) {
            list.push(benefit);
          }
        }
        if ((item.claimCode === lossOfIncomeCode || item.parentBenefitCode === lossOfIncomeCode) && isLossOfIncomeCodeSelected) {
          const benefit = mapQuestionItem(item, 'Loss of income');
          if (!!benefit) {
            list.push(benefit);
          }
        }
        if ((item.claimCode === lossOfLifeCode || item.parentBenefitCode === lossOfLifeCode) && isLossOfLifeCodeSelected) {
          const benefit = mapQuestionItem(item, 'Loss of Life');
          if (!!benefit) {
            list.push(benefit);
          }
        }
        if ((item.claimCode === totalPermanentDisablementCode || item.parentBenefitCode === totalPermanentDisablementCode) && isTotalPermanentDisablementCodeSelected) {
          const benefit = mapQuestionItem(item, 'Total permanent disablement');
          if (!!benefit) {
            list.push(benefit);
          }
        }
      }
    );
  }

  // Trip Interruption
  if ((tripCancellation === 'true' || tripCancellationForAnyReason === 'true' || travelInterruption === 'true') && claimTypesInit !== undefined) {
    const code1 = stepTripCancellationAndTripInterruptionExpenseLookup.tripCancellation.claimCode;
    const code2 = stepTripCancellationAndTripInterruptionExpenseLookup.tripCancellationForAnyReason.claimCode;
    const code3 = stepTripCancellationAndTripInterruptionExpenseLookup.travelInterruption.claimCode;
    claimTypesInit.forEach(
      (item) => {
        if ((item.claimCode === code1 || item.parentBenefitCode === code1) && tripCancellation === 'true') {
          const benefit = mapQuestionItem(item, 'Trip Cancellation');
          if (!!benefit) {
            list.push(benefit);
          }
        }
        if ((item.claimCode === code2 || item.parentBenefitCode === code2) && tripCancellationForAnyReason === 'true') {
          const benefit = mapQuestionItem(item, 'Trip Cancellation For Any Reason');
          if (!!benefit) {
            list.push(benefit);
          }
        }
        if ((item.claimCode === code3 || item.parentBenefitCode === code3) && travelInterruption === 'true') {
          const benefit = mapQuestionItem(item, 'Trip Interruption');
          if (!!benefit) {
            list.push(benefit);
          }
        }
      }
    );
  }

  // Changes To Your Journey Trawick
  if (selectedBenefitsChangesToYourJourney.length > 0) {
    list.push(...selectedBenefitsChangesToYourJourney);
  }

  // Medical Expense Trawick
  if (selectedBenefitsMedicalExpense.length > 0) {
    list.push(...selectedBenefitsMedicalExpense);
  }

  // Baggage and personal items Starr
  if (selectedBenefitsBaggageAndPersonalItemsStarr.length > 0) {
    list.push(...selectedBenefitsBaggageAndPersonalItemsStarr);
  }

  // Other Documents Starr
  if (selectedBenefitsOtherStarr.length > 0) {
    list.push(...selectedBenefitsOtherStarr);
  }

  // Medical and Evacuation SCTI
  const medicalAndEvacuationSCTISelected = !!whatExpensesAreYouClaimingForMedicalAndEvacuationSCTI && typeof whatExpensesAreYouClaimingForMedicalAndEvacuationSCTI.toJS === 'function'
    ? whatExpensesAreYouClaimingForMedicalAndEvacuationSCTI.toJS()
    : whatExpensesAreYouClaimingForMedicalAndEvacuationSCTI || [];

  const MAEWhatAreYourExpensesRelatedToSelected = !!MAEWhatAreYourExpensesRelatedTo && typeof MAEWhatAreYourExpensesRelatedTo.toJS === 'function'
    ? MAEWhatAreYourExpensesRelatedTo.toJS()
    : MAEWhatAreYourExpensesRelatedTo || [];

  const isMedicalHospitalExpensesSelected = medicalAndEvacuationSCTISelected.includes('Medical & Hospital Expenses');
  const isDentalExpensesSelected = medicalAndEvacuationSCTISelected.includes('Dental Expenses');
  const isFuneralExpensesSelected = medicalAndEvacuationSCTISelected.includes('Funeral Expenses');
  const isExpensesarisingfromterrorismSelected = medicalAndEvacuationSCTISelected.includes('Expenses arising from terrorism');
  const isExtraTravelAndAccommodationSelected = MAEWhatAreYourExpensesRelatedToSelected.includes('Extra travel and accommodation');

  if ((didAnAccompanyingPersonTravelFromYourHomeCountryWhilstYouWereHospitalised === 'true' || wasTheDeathCausedByAnInjury === 'true' || isMedicalHospitalExpensesSelected || isDentalExpensesSelected
    || isFuneralExpensesSelected || isExpensesarisingfromterrorismSelected || isExtraTravelAndAccommodationSelected) && claimTypesInit !== undefined) {
    const medicalHospitalExpensesCode = stepMedicalAndEvacuationLookup.medicalHospitalExpenses.claimCode;
    const accompanyingPersonCode = stepMedicalAndEvacuationLookup.didAnAccompanyingPersonTravelFromYourHomeCountryWhilstYouWerehospitalised.claimCode;
    const funeralExpensesCode = stepMedicalAndEvacuationLookup.funeralExpenses.claimCode;
    const lossOfLifeCode = stepMedicalAndEvacuationLookup.wasTheDeathCausedByAnInjury.claimCode;
    const extraTravelAndAccommodationCode = stepMedicalAndEvacuationLookup.extraTravelAndAccommodation.claimCode;
    claimTypesInit.forEach(
      (item) => {
        if ((item.claimCode === medicalHospitalExpensesCode || item.parentBenefitCode === medicalHospitalExpensesCode) && (isMedicalHospitalExpensesSelected || isDentalExpensesSelected
          || isExpensesarisingfromterrorismSelected || isFuneralExpensesSelected || isExtraTravelAndAccommodationSelected)) {
          const benefit = mapQuestionItem(item, 'Medical and evacuation');
          if (!!benefit) {
            list.push(benefit);
          }
        }
        if ((item.claimCode === accompanyingPersonCode || item.parentBenefitCode === accompanyingPersonCode) && didAnAccompanyingPersonTravelFromYourHomeCountryWhilstYouWereHospitalised === 'true') {
          const benefit = mapQuestionItem(item, 'Accompanying Person');
          if (!!benefit) {
            list.push(benefit);
          }
        }
        // Funeral expenses
        if ((item.claimCode === funeralExpensesCode || item.parentBenefitCode === funeralExpensesCode) && isFuneralExpensesSelected) {
          const benefit = mapQuestionItem(item, 'Funeral expenses or return of mortal remains');
          if (!!benefit) {
            list.push(benefit);
          }
        }
        // Loss Of Life
        if ((item.claimCode === lossOfLifeCode || item.parentBenefitCode === lossOfLifeCode) && wasTheDeathCausedByAnInjury === 'true') {
          const benefit = mapQuestionItem(item, 'Loss Of Life');
          if (!!benefit) {
            list.push(benefit);
          }
        }
        // Extra travel and accommodation
        if ((item.claimCode === extraTravelAndAccommodationCode || item.parentBenefitCode === extraTravelAndAccommodationCode) && isExtraTravelAndAccommodationSelected && isShowSubBenefits) {
          const benefit = mapQuestionItem(item, 'Extra travel and accommodation');
          if (!!benefit) {
            list.push(benefit);
          }
        }
      }
    );
  }

  const baggageAndPersonalItemsSelected = !!whatHappenedToYourBaggageAndPersonalItems && typeof whatHappenedToYourBaggageAndPersonalItems.toJS === 'function'
    ? whatHappenedToYourBaggageAndPersonalItems.toJS()
    : whatHappenedToYourBaggageAndPersonalItems || [];

  const damagedItemsSelected = !!whatItemsAreYouClaimingFor && typeof whatItemsAreYouClaimingFor.toJS === 'function'
    ? whatItemsAreYouClaimingFor.toJS()
    : whatItemsAreYouClaimingFor || [];

  const isDaggageDelaySelected = baggageAndPersonalItemsSelected.includes('Baggage delay');
  const isEssentialMedicationSelected = damagedItemsSelected.includes('Essential medication');
  const isSpecifiedHighValueItemsSelected = damagedItemsSelected.includes('Specified high value items');
  const isBankCardsOrTravelDocumentsSelected = damagedItemsSelected.includes('Bank cards or travel documents');
  const isCashSelected = damagedItemsSelected.includes('Cash');
  const isJewelleryOrTraditionalWatchesSelected = damagedItemsSelected.includes('Jewellery or traditional watches');
  const isUnspecifiedLaptopSelected = damagedItemsSelected.includes('Laptops, tablets or cameras');
  const isOtherUnspecifiedItemsSelected = damagedItemsSelected.includes('Other unspecified items');
  const listPolicyHideParentDocuments = ['INT-COMP-AU', 'WORK-AU', 'INT-COMP-NZ', 'WORK-NZ', 'VISIT-NZ'];
  const isShowParentDocuments = !listPolicyHideParentDocuments.includes(policyTypeCode);

  if ((isDaggageDelaySelected || isEssentialMedicationSelected || isSpecifiedHighValueItemsSelected || isBankCardsOrTravelDocumentsSelected ||
    isCashSelected || isJewelleryOrTraditionalWatchesSelected || isUnspecifiedLaptopSelected || isOtherUnspecifiedItemsSelected) && claimTypesInit !== undefined) {
    const baggageAndPersonalItemsCode = stepBaggageAndPersonalItemsSCTILookup.baggageAndPersonalItems.claimCode;
    const daggageDelayCode = stepBaggageAndPersonalItemsSCTILookup.daggageDelay.claimCode;
    const essentialMedicationCode = stepBaggageAndPersonalItemsSCTILookup.essentialMedication.claimCode;
    const specifiedHighValueItemsCode = stepBaggageAndPersonalItemsSCTILookup.specifiedHighValueItems.claimCode;
    const bankCardsOrTravelDocumentsCode = stepBaggageAndPersonalItemsSCTILookup.bankCardsOrTravelDocuments.claimCode;

    claimTypesInit.forEach(
      (item) => {
        if ((item.claimCode === baggageAndPersonalItemsCode || item.parentBenefitCode === baggageAndPersonalItemsCode) && (isDaggageDelaySelected || isEssentialMedicationSelected
          || isSpecifiedHighValueItemsSelected || isJewelleryOrTraditionalWatchesSelected || isUnspecifiedLaptopSelected
          || isOtherUnspecifiedItemsSelected || ((isBankCardsOrTravelDocumentsSelected || isCashSelected) && isShowParentDocuments))) {
          const benefit = mapQuestionItem(item, 'Baggage and Personal Items');
          if (!!benefit) {
            list.push(benefit);
          }
        }
        if ((item.claimCode === daggageDelayCode || item.parentBenefitCode === daggageDelayCode) && isDaggageDelaySelected) {
          const benefit = mapQuestionItem(item, 'Baggage delay');
          if (!!benefit) {
            list.push(benefit);
          }
        }
        if ((item.claimCode === essentialMedicationCode || item.parentBenefitCode === essentialMedicationCode) && isEssentialMedicationSelected) {
          const benefit = mapQuestionItem(item, 'Essential medication');
          if (!!benefit) {
            list.push(benefit);
          }
        }
        if ((item.claimCode === specifiedHighValueItemsCode || item.parentBenefitCode === specifiedHighValueItemsCode) && isSpecifiedHighValueItemsSelected) {
          const benefit = mapQuestionItem(item, 'Specified high value items');
          if (!!benefit) {
            list.push(benefit);
          }
        }
        if ((item.claimCode === bankCardsOrTravelDocumentsCode || item.parentBenefitCode === bankCardsOrTravelDocumentsCode) && (isBankCardsOrTravelDocumentsSelected || isCashSelected)) {
          const benefit = mapQuestionItem(item, 'Cash, bank cards, travel documents and passports');
          if (!!benefit) {
            list.push(benefit);
          }
        }
      }
    );
  }

  // Changes to your journey SCTI
  const didYouAlsoIncurTheseCostsAsAResultOfYourTravelDisruptionSelected = !!didYouAlsoIncurTheseCostsAsAResultOfYourTravelDisruption && typeof didYouAlsoIncurTheseCostsAsAResultOfYourTravelDisruption.toJS === 'function'
    ? didYouAlsoIncurTheseCostsAsAResultOfYourTravelDisruption.toJS()
    : didYouAlsoIncurTheseCostsAsAResultOfYourTravelDisruption || [];
  const isChildCareExpensesSelected = didYouAlsoIncurTheseCostsAsAResultOfYourTravelDisruptionSelected.includes('Childcare expenses');
  const isPetBoardingFacilitySelected = didYouAlsoIncurTheseCostsAsAResultOfYourTravelDisruptionSelected.includes('Pet boarding facility');
  if ((haveYouCanceledOrChangedYourJourneyBeforeLeaving === 'true' || wasTheUnexpectedEventRelatedToTheRelevantPersonsExistingHealthCondition !== '' || wereYouChargedACancellationFeeByTheTravelAgent === 'true' || wereYouDelayedWhileTravelingToASpecialEvent === 'true'
    || haveYouChangedYourJourneyAfterLeaving === 'true' || wereYouDelayedWhileTravelingToASpecialEventAL === 'true' || isChildCareExpensesSelected || isPetBoardingFacilitySelected
    || wasTheUnexpectedEventRelatedToTheRelevantPersonsExistingHealthConditionAL === 'true') && claimTypesInit !== undefined) {
    // Cancelling or changing your journey before you leave
    const cancellingOrChangingYourJourneyBLCode = stepChangesToYourJourneyLookup.haveYouCanceledOrChangedYourJourneyBeforeLeaving.claimCode;
    const existingConditionOfARelevantPersonCode = stepChangesToYourJourneyLookup.wasTheUnexpectedEventRelatedToTheRelevantPersonsExistingHealthConditionYes.claimCode;
    const travelAgentCancellationFeeCode = stepChangesToYourJourneyLookup.wereYouChargedACancellationFeeByTheTravelAgent.claimCode;
    const delayedJourneyToASpecialEventCode = stepChangesToYourJourneyLookup.wereYouDelayedWhileTravelingToASpecialEvent.claimCode;
    // Changes to your journey once you have left
    const cancellingOrChangingYourJourneyALCode = stepChangesToYourJourneyLookup.haveYouChangedYourJourneyAfterLeaving.claimCode;
    const delayedJourneyToASpecialEventALCode = stepChangesToYourJourneyLookup.wereYouDelayedWhileTravelingToASpecialEventAL.claimCode;
    const childCareExpensesCode = stepChangesToYourJourneyLookup.childCareExpenses.claimCode;
    const petBoardingFacilityCode = stepChangesToYourJourneyLookup.petBoardingFacility.claimCode;
    const existingConditionOfARelevantPersonALCode = stepChangesToYourJourneyLookup.wasTheUnexpectedEventRelatedToTheRelevantPersonsExistingHealthConditionAL.claimCode;
    claimTypesInit.forEach(
      (item) => {
        // Cancelling or changing your journey before you leave
        if ((item.claimCode === cancellingOrChangingYourJourneyBLCode || item.parentBenefitCode === cancellingOrChangingYourJourneyBLCode) && (haveYouCanceledOrChangedYourJourneyBeforeLeaving === 'true' || wereYouChargedACancellationFeeByTheTravelAgent === 'true')) {
          const benefit = mapQuestionItem(item, 'Cancelling or changing your journey before you leave');
          if (!!benefit) {
            list.push(benefit);
          }
        }
        if ((item.claimCode === existingConditionOfARelevantPersonCode || item.parentBenefitCode === existingConditionOfARelevantPersonCode) && wasTheUnexpectedEventRelatedToTheRelevantPersonsExistingHealthCondition === 'true') {
          const benefit = mapQuestionItem(item, 'Existing condition of a relevant person');
          if (!!benefit) {
            list.push(benefit);
          }
        }
        if ((item.claimCode === travelAgentCancellationFeeCode || item.parentBenefitCode === travelAgentCancellationFeeCode) && wereYouChargedACancellationFeeByTheTravelAgent === 'true') {
          const benefit = mapQuestionItem(item, 'Travel Agent Cancellation fee');
          if (!!benefit) {
            list.push(benefit);
          }
        }
        if ((item.claimCode === delayedJourneyToASpecialEventCode || item.parentBenefitCode === delayedJourneyToASpecialEventCode) && wereYouDelayedWhileTravelingToASpecialEvent === 'true') {
          const benefit = mapQuestionItem(item, 'Delayed journey to a special event');
          if (!!benefit) {
            list.push(benefit);
          }
        }
        // Changes to your journey once you have left
        if ((item.claimCode === cancellingOrChangingYourJourneyALCode || item.parentBenefitCode === cancellingOrChangingYourJourneyALCode) && haveYouChangedYourJourneyAfterLeaving === 'true') {
          const benefit = mapQuestionItem(item, 'Changes to your journey once you have left');
          if (!!benefit) {
            list.push(benefit);
          }
        }
        if ((item.claimCode === delayedJourneyToASpecialEventALCode || item.parentBenefitCode === delayedJourneyToASpecialEventALCode) && wereYouDelayedWhileTravelingToASpecialEventAL === 'true') {
          const benefit = mapQuestionItem(item, 'Delayed journey to a special event');
          if (!!benefit) {
            list.push(benefit);
          }
        }
        if ((item.claimCode === existingConditionOfARelevantPersonALCode || item.parentBenefitCode === existingConditionOfARelevantPersonALCode) && wasTheUnexpectedEventRelatedToTheRelevantPersonsExistingHealthConditionAL === 'true') {
          const benefit = mapQuestionItem(item, 'Existing condition of a relevant person');
          if (!!benefit) {
            list.push(benefit);
          }
        }
        if ((item.claimCode === childCareExpensesCode || item.parentBenefitCode === childCareExpensesCode) && isChildCareExpensesSelected) {
          const benefit = mapQuestionItem(item, 'Childcare expenses');
          if (!!benefit) {
            list.push(benefit);
          }
        }
        if ((item.claimCode === petBoardingFacilityCode || item.parentBenefitCode === petBoardingFacilityCode) && isPetBoardingFacilitySelected) {
          const benefit = mapQuestionItem(item, 'Pet services');
          if (!!benefit) {
            list.push(benefit);
          }
        }
      }
    );
  }

  // Bank Cards or travel documents and Cash SCTI
  const cashBankCardsTravelDocumentsAndPassportsSelected = !!passportItemsClaiming && typeof passportItemsClaiming.toJS === 'function'
    ? passportItemsClaiming.toJS()
    : passportItemsClaiming || [];
  const isPassportsBankCardsOrTravelDocumentsSelected = cashBankCardsTravelDocumentsAndPassportsSelected.includes('Bank cards or travel documents');
  const isPassportsCashSelected = cashBankCardsTravelDocumentsAndPassportsSelected.includes('Cash');

  if ((isPassportsBankCardsOrTravelDocumentsSelected || isPassportsCashSelected) && claimTypesInit !== undefined) {
    const bankCardsOrTravelDocumentsCode = stepCashBankCardsTravelDocumentsAndPassportsLookup.bankCardsOrTravelDocuments.claimCode;

    claimTypesInit.forEach(
      (item) => {
        if ((item.claimCode === bankCardsOrTravelDocumentsCode || item.parentBenefitCode === bankCardsOrTravelDocumentsCode) && (isPassportsBankCardsOrTravelDocumentsSelected || isPassportsCashSelected)) {
          const benefit = mapQuestionItem(item, 'Cash, bank cards, travel documents and passports');
          if (!!benefit) {
            list.push(benefit);
          }
        }
      }
    );
  }

  // Medical Expenses Tugo
  const {
    whatExpensesAreYouClaimingFor: whatExpensesAreYouClaimingForMedicalExpensesTugo,
    isClaimRelatedToSelfInflictedYes,
    isClaimRelatedToSelfInflictedNo,
    isYourClaimRelatedToASelfInflictedInjuryOrSuicideAttempt,
    isYourClaimRelatedToPsychiatricTreatment,
    isYourClaimRelatedToHIV,
    diagnosticImaging,
  } = stepMedicalExpensesTugoData || {};

  const medicalExpensesTugoSelected = !!whatExpensesAreYouClaimingForMedicalExpensesTugo && typeof whatExpensesAreYouClaimingForMedicalExpensesTugo.toJS === 'function'
    ? whatExpensesAreYouClaimingForMedicalExpensesTugo.toJS()
    : whatExpensesAreYouClaimingForMedicalExpensesTugo || [];

  const isClaimRelatedToSelfInflictedYesChecked = isClaimRelatedToSelfInflictedYes === 'true' || isYourClaimRelatedToASelfInflictedInjuryOrSuicideAttempt === 'yes';
  const isClaimRelatedToSelfInflictedNoChecked = isClaimRelatedToSelfInflictedNo === 'true';

  const isNonMRIChecked = diagnosticImaging && diagnosticImaging.includes('diagnosticNonMRI');
  const isMRIChecked = diagnosticImaging && diagnosticImaging.includes('diagnosticMRI');

  const isMaternityExpenseSelected = medicalExpensesTugoSelected.includes('Maternity Expense');
  const isOncologySelected = medicalExpensesTugoSelected.includes('Oncology');
  const isCleftLipAndPalateAssistanceSelected = medicalExpensesTugoSelected.includes('Cleft Lip and Palate Assistance');
  const isWellBabyCareSelected = medicalExpensesTugoSelected.includes('Well Baby Care');
  const isAnnualHealthExamSelected = medicalExpensesTugoSelected.includes('Annual Health Exam');
  const isVaccinationExpensesSelected = medicalExpensesTugoSelected.includes('Vaccination Expenses');
  const isbloodPlasmaOrWholeBloodTransfusionSelected = medicalExpensesTugoSelected.includes('Blood plasma or whole blood (transfusion)');
  const isAnaesthesiologySelected = medicalExpensesTugoSelected.includes('Anaesthesiology');
  const isDentalSurgerySelected = medicalExpensesTugoSelected.includes('Dental Surgery');

  const isYourClaimRelatedToPsychiatricTreatmentChecked = isYourClaimRelatedToPsychiatricTreatment === 'yes';
  const isYourClaimRelatedToHIVChecked = isYourClaimRelatedToHIV === 'yes';
  const isHospitalizationChargesChecked = isYourClaimRelatedToHIV === 'no';

  if (medicalExpensesTugoSelected.length > 0 && claimTypesInit !== undefined) {
    const outpatientDoctorOrClinicVisitCode = stepMedicalExpensesTugoLookup.outpatientDoctorOrClinicVisit.claimCode;
    const isClaimRelatedToSelfInflictedCode = stepMedicalExpensesTugoLookup.isYourClaimRelatedToASelfInflictedInjuryOrSuicideAttemptYes.claimCode;

    const diagnosticMRICode = stepMedicalExpensesTugoLookup.diagnosticMRI.claimCode;
    const diagnosticNonMRICode = stepMedicalExpensesTugoLookup.diagnosticNonMRI.claimCode;

    const maternityExpenseCode = stepMedicalExpensesTugoLookup.maternityExpense.claimCode;
    const oncologyCode = stepMedicalExpensesTugoLookup.oncology.claimCode;
    const cleftLipAndPalateAssistanceCode = stepMedicalExpensesTugoLookup.cleftLipAndPalateAssistance.claimCode;
    const wellBabyCareCode = stepMedicalExpensesTugoLookup.wellBabyCare.claimCode;
    const annualHealthExamCode = stepMedicalExpensesTugoLookup.annualHealthExam.claimCode;
    const vaccinationExpensesCode = stepMedicalExpensesTugoLookup.vaccinationExpenses.claimCode;
    const psychiatricTreatmentCode = stepMedicalExpensesTugoLookup.isYourClaimRelatedToPsychiatricTreatment.claimCode;
    const HIVCode = stepMedicalExpensesTugoLookup.isYourClaimRelatedToHIV.claimCode;
    const bloodPlasmaOrWholeBloodTransfusionCode = stepMedicalExpensesTugoLookup.bloodPlasmaOrWholeBloodTransfusion.claimCode;
    const anaesthesiologyCode = stepMedicalExpensesTugoLookup.anaesthesiology.claimCode;
    const dentalSurgeryCode = stepMedicalExpensesTugoLookup.dentalSurgery.claimCode;

    claimTypesInit.forEach(
      (item) => {
        if ((item.claimCode === outpatientDoctorOrClinicVisitCode || item.parentBenefitCode === outpatientDoctorOrClinicVisitCode) && isClaimRelatedToSelfInflictedNoChecked) {
          const benefit = mapQuestionItem(item, 'Outpatient Doctor or Clinic Visit');
          if (!!benefit) {
            list.push(benefit);
          }
        }
        if ((item.claimCode === isClaimRelatedToSelfInflictedCode || item.parentBenefitCode === isClaimRelatedToSelfInflictedCode) && isClaimRelatedToSelfInflictedYesChecked) {
          const benefit = mapQuestionItem(item, 'Self Inflicted Injuries and Attempted Suicide');
          if (!!benefit) {
            list.push(benefit);
          }
        }

        if ((item.claimCode === diagnosticMRICode || item.parentBenefitCode === diagnosticMRICode) && isMRIChecked) {
          const benefit = mapQuestionItem(item, 'MRI Scans');
          if (!!benefit) {
            list.push(benefit);
          }
        }
        if ((item.claimCode === diagnosticNonMRICode || item.parentBenefitCode === diagnosticNonMRICode) && isNonMRIChecked) {
          const benefit = mapQuestionItem(item, 'Standard X-Ray and Laboratory Examinations');
          if (!!benefit) {
            list.push(benefit);
          }
        }
        if ((item.claimCode === maternityExpenseCode || item.parentBenefitCode === maternityExpenseCode) && isMaternityExpenseSelected) {
          const benefit = mapQuestionItem(item, 'Maternity Expense');
          if (!!benefit) {
            list.push(benefit);
          }
        }
        if ((item.claimCode === oncologyCode || item.parentBenefitCode === oncologyCode) && isOncologySelected) {
          const benefit = mapQuestionItem(item, 'Oncology');
          if (!!benefit) {
            list.push(benefit);
          }
        }
        if ((item.claimCode === cleftLipAndPalateAssistanceCode || item.parentBenefitCode === cleftLipAndPalateAssistanceCode) && isCleftLipAndPalateAssistanceSelected) {
          const benefit = mapQuestionItem(item, 'Cleft Lip and Palate Assistance');
          if (!!benefit) {
            list.push(benefit);
          }
        }
        if ((item.claimCode === wellBabyCareCode || item.parentBenefitCode === wellBabyCareCode) && isWellBabyCareSelected) {
          const benefit = mapQuestionItem(item, 'Well Baby Care');
          if (!!benefit) {
            list.push(benefit);
          }
        }
        if ((item.claimCode === annualHealthExamCode || item.parentBenefitCode === annualHealthExamCode) && isAnnualHealthExamSelected) {
          const benefit = mapQuestionItem(item, 'Annual Health Exam');
          if (!!benefit) {
            list.push(benefit);
          }
        }
        if ((item.claimCode === vaccinationExpensesCode || item.parentBenefitCode === vaccinationExpensesCode) && isVaccinationExpensesSelected) {
          const benefit = mapQuestionItem(item, 'Vaccination Expenses');
          if (!!benefit) {
            list.push(benefit);
          }
        }
        if ((item.claimCode === psychiatricTreatmentCode || item.parentBenefitCode === psychiatricTreatmentCode) && isYourClaimRelatedToPsychiatricTreatmentChecked) {
          const benefit = mapQuestionItem(item, 'Hospital Charges Related to Psychiatric Treatment');
          if (!!benefit) {
            list.push(benefit);
          }
        }
        if ((item.claimCode === HIVCode || item.parentBenefitCode === HIVCode) && isYourClaimRelatedToHIVChecked) {
          const benefit = mapQuestionItem(item, 'Hospital Charges Related to HIV');
          if (!!benefit) {
            list.push(benefit);
          }
        }
        if ((item.claimCode === HIVCode || item.parentBenefitCode === HIVCode) && isHospitalizationChargesChecked) {
          const benefit = mapQuestionItem(item, 'Hospitalization Charges');
          if (!!benefit) {
            list.push(benefit);
          }
        }
        if ((item.claimCode === bloodPlasmaOrWholeBloodTransfusionCode || item.parentBenefitCode === bloodPlasmaOrWholeBloodTransfusionCode) && isbloodPlasmaOrWholeBloodTransfusionSelected) {
          const benefit = mapQuestionItem(item, 'Blood plasma or whole blood (transfusion)');
          if (!!benefit) {
            list.push(benefit);
          }
        }
        if ((item.claimCode === anaesthesiologyCode || item.parentBenefitCode === anaesthesiologyCode) && isAnaesthesiologySelected) {
          const benefit = mapQuestionItem(item, 'Anaesthesiology');
          if (!!benefit) {
            list.push(benefit);
          }
        }
        if ((item.claimCode === dentalSurgeryCode || item.parentBenefitCode === dentalSurgeryCode) && isDentalSurgerySelected) {
          const benefit = mapQuestionItem(item, 'Dental Surgery');
          if (!!benefit) {
            list.push(benefit);
          }
        }
      }
    );
  }

  // Other Expenses Tugo
  const selectedBenefitsOtherTugo = stepOtherTugoDataMapper.mapToClaimExpensesLevel(stepOtherTugoData, claimTypesInit, selectedBenefits);
  if (selectedBenefitsOtherTugo.length > 0) {
    list.push(...selectedBenefitsOtherTugo);
  }

  // Tugo Benefits
  const selectedBenefitsBaseVictorsMedical = stepBaseVictorsMedicalTugoDataMapper.mapToClaimExpensesLevel(stepBaseVictorsMedicalTugoData, claimTypesInit, selectedBenefits);
  // Medical Expenses Tugo
  if (selectedBenefitsBaseVictorsMedical.length > 0) {
    list.push(...selectedBenefitsBaseVictorsMedical);
  }

  const selectedBenefitsStudentMedical = stepStudentMedicalBenefitsTugoDataMapper.mapToClaimExpensesLevel(stepStudentMedicalBenefitsTugoData, claimTypesInit, selectedBenefits);
  if (selectedBenefitsStudentMedical.length > 0) {
    list.push(...selectedBenefitsStudentMedical);
  }

  const selectedBenefitsTripCancellationTugo = stepTripCancellationTugoDataMapper.mapToClaimExpensesLevel(stepTripCancellationTugoData, claimTypesInit, selectedBenefits);
  if (selectedBenefitsTripCancellationTugo.length > 0) {
    list.push(...selectedBenefitsTripCancellationTugo);
  }

  const selectedBenefitsTripCancellationTravellerTugo = stepTripCancellationTravellerTugoDataMapper.mapToClaimExpensesLevel(stepTripCancellationTravellerTugoData, claimTypesInit, selectedBenefits);
  if (selectedBenefitsTripCancellationTravellerTugo.length > 0) {
    list.push(...selectedBenefitsTripCancellationTravellerTugo);
  }

  const normalizedPolicyPlanIds = Array.isArray(policyPlanIds)
    ? policyPlanIds
    : (policyPlanIds && typeof policyPlanIds.toJS === 'function' ? policyPlanIds.toJS() : []);
  const isTripInterruptionTravellerPolicy = LIST_POLICY_TYPE_CODE.LIST_POLICY_TYPE_CODE_TRIP_CANCELLATION_TRAVELLER.includes(policyTypeCode)
    || normalizedPolicyPlanIds.some((planId) => LIST_POLICY_TYPE_CODE.LIST_POLICY_TYPE_CODE_TRIP_CANCELLATION_TRAVELLER.includes(planId))
    || LIST_POLICY_TYPE_CODE.LIST_POLICY_PLAN_ID_TRIP_INTERRUPTION_TRAVELLER.includes(policyTypeCode)
    || normalizedPolicyPlanIds.some((planId) => LIST_POLICY_TYPE_CODE.LIST_POLICY_PLAN_ID_TRIP_INTERRUPTION_TRAVELLER.includes(planId));
  const isADAndDTravellerPolicy = LIST_POLICY_TYPE_CODE.LIST_POLICY_PLAN_ID_AD_AND_D_TRAVELLER.includes(policyTypeCode)
    || normalizedPolicyPlanIds.some((planId) => LIST_POLICY_TYPE_CODE.LIST_POLICY_PLAN_ID_AD_AND_D_TRAVELLER.includes(planId));
  const tripInterruptionDataMapper = isTripInterruptionTravellerPolicy
    ? stepTripInterruptionTravellerTugoDataMapper
    : stepTripInterruptionTugoDataMapper;
  const selectedBenefitsTripInterruptionTugo = tripInterruptionDataMapper.mapToClaimExpensesLevel(
    stepTripInterruptionTugoData,
    claimTypesInit,
    selectedBenefits
  );
  if (selectedBenefitsTripInterruptionTugo.length > 0) {
    list.push(...selectedBenefitsTripInterruptionTugo);
  }

  // Standard VTC Medical Benefits
  const selectedBenefitsStandardVTCMedical = stepStandardVTCMedicalBenefitsTugoDataMapper.mapToClaimExpensesLevel(stepStandardVTCMedicalBenefitsTugoData, claimTypesInit, selectedBenefits);
  if (selectedBenefitsStandardVTCMedical.length > 0) {
    list.push(...selectedBenefitsStandardVTCMedical);
  }

  // Traveller Medical Benefits
  const selectedBenefitsTravellerMedical = stepTravellerMedicalBenefitsTugoDataMapper.mapToClaimExpensesLevel(stepTravellerMedicalBenefitsTugoData, claimTypesInit, selectedBenefits);
  if (selectedBenefitsTravellerMedical.length > 0) {
    list.push(...selectedBenefitsTravellerMedical);
  }

  // Optimum Medical Benefits
  const selectedBenefitsOptimumMedical = stepOptimumMedicalBenefitsTugoDataMapper.mapToClaimExpensesLevel(stepOptimumMedicalBenefitsTugoData, claimTypesInit, selectedBenefits);
  if (selectedBenefitsOptimumMedical.length > 0) {
    list.push(...selectedBenefitsOptimumMedical);
  }

  // AD&D Benefits Tugo
  const selectedBenefitsADAndDTugo = (isADAndDTravellerPolicy ? stepADAndDTravellerTugoDataMapper : stepADAndDTugoDataMapper).mapToClaimExpensesLevel(stepADAndDBenefitsTugoData || {}, claimTypesInit, selectedBenefits);
  if (selectedBenefitsADAndDTugo.length > 0) {
    list.push(...selectedBenefitsADAndDTugo);
  }

  // Baggage Traveller Benefits
  const selectedBenefitsBaggageAndPersonalItemsTraveller = stepBaggageAndPersonalItemsTravellerTugoDataMapper.mapToClaimExpensesLevel(stepBaggageAndPersonalItemsTravellerTugoData || {}, claimTypesInit, selectedBenefits);
  if (selectedBenefitsBaggageAndPersonalItemsTraveller.length > 0) {
    list.push(...selectedBenefitsBaggageAndPersonalItemsTraveller);
  }

  // Rental Car Protection Traveller Benefits
  const selectedBenefitsRentalCarProtectionTraveller = stepRentalCarProtectionTravellerTugoDataMapper.mapToClaimExpensesLevel(stepRentalCarProtectionTravellerTugoData || {}, claimTypesInit, selectedBenefits);
  if (selectedBenefitsRentalCarProtectionTraveller.length > 0) {
    list.push(...selectedBenefitsRentalCarProtectionTraveller);
  }

  return list;
}

export default {
  mapToParentSection,
  mapToQuestionnaire,
  mapToExpenses,
  mapDocumentItems,
  mapQuestionItem,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/dataMapper/stepSupportingDocumentsDataMapper.js